<app-page-title></app-page-title>
<div class="h9-text black-40 mb-1">
  Знайдено результатів: <span class="black-80">{{ searchService.totalRows }}</span>
</div>

<div style="width: calc(100vw - 268px); max-height: calc(100vh - 284px);">

  <div class="error-container mt-1" *ngIf="!searchService.content || searchService.content.length === 0">
    <app-error [errorCode]="404"></app-error>
  </div>


  <p-virtualScroller [value]="searchService.content"
                     *ngIf="searchService.content && searchService.content.length !== 0"
                     [itemSize]="136"
                     [delay]="250"
                     [lazy]="true"
                     #vs
                     class="surface-border border-round"
                     (onLazyLoad)="onLazyLoad($event)"
                     scrollHeight="calc(94vh - 284px)"
                     [style]="{ 'height': 'calc(94vh - 284px)', width: 'calc(100vw - 268px)'}">
    <ng-template let-chunk pTemplate="item">
      <div class="flex flex-center">
        <div class="col-4" *ngFor="let result of chunk; let first = first ; let last = last;" [style.padding-left]="first ? '0' : '8'">
          <div class="result-card" #newTask (click)="goTo(result)"
           [ngClass]="newTask.matches(':hover') ? 'background-249 shadow-2 cursor-pointer': ''"
           (mouseover)="''" (mouseleave)="''">
        <div class="flex flex-center" style="height: 30px">
          <med-bubble *ngIf="result.type === 'good'" [styleClass]="'med-bubble-search-reserves'">
            <div class="flex flex-center">
              <med-icon-car size="16"></med-icon-car>
              <div class="h10-text ml-1">Запаси</div>
            </div>
          </med-bubble>



          <med-bubble *ngIf="result.type === 'supply'" [styleClass]="'med-bubble-search-supply'">
            <div class="flex flex-center">
              <img src="assets/icons/ic24-package.svg" height="16"/>
              <div class="h10-text ml-1">Поставки</div>
            </div>
          </med-bubble>

          <med-bubble *ngIf="result.type === 'distribution'" [styleClass]="'med-bubble-search-distribution'">
            <div class="flex flex-center">
              <med-icon-transaction size="16"></med-icon-transaction>
              <div class="h10-text ml-1">Розподіли</div>
            </div>
          </med-bubble>

          <med-bubble *ngIf="result.type === 'subdistribution'" [styleClass]="'med-bubble-search-supply'">
            <div class="flex flex-center">
              <med-icon-transaction size="16"></med-icon-transaction>
              <div class="h10-text ml-1">Дочірній розподіл</div>
            </div>
          </med-bubble>
          <med-bubble *ngIf="result.type === 'organization'" [styleClass]="'med-bubble-search-supply'">
            <div class="flex flex-center">
              <med-icon-hospital-building size="16"></med-icon-hospital-building>
              <div class="h10-text ml-1">Організація</div>
            </div>
          </med-bubble>

          <med-bubble *ngIf="result.type === 'postponed'" [styleClass]="'med-bubble-search-postponed'">
            <div class="flex flex-center">
              <med-icon-hospital-building size="16"></med-icon-hospital-building>
              <div class="h10-text ml-1">Відтерміноване</div>
            </div>
          </med-bubble>

          <med-bubble [styleClass]="'med-bubble-search-fieldName ml-2'">
            <div class="flex flex-center">
              <div class="h10-text ml-1">{{result.field}}</div>
            </div>
          </med-bubble>
        </div>
        <div class="black-60 h10-text mt-1 mb-1" [pTooltip]="name">
                        <span class="truncate-text-1row">
                          {{result.name}}
                        </span>
          <ng-template #name >
            <div class="flex items-center h10-text black-20 bg-transparent">
              {{result.name}}
            </div>
          </ng-template>
        </div>
        <div class="truncate-text">
          <div [innerHTML]="sanitize(result.text)" class="h10-text black-80" *ngIf="result.field != 'Компоненти'" [pTooltip]="text"></div>
          <div [innerHTML]="sanitize('Розподіл №' + result.id)" class="h10-text black-80" *ngIf="result.field === 'Компоненти'"></div>
          <ng-template #text >
            <div class="flex items-center h10-text" style="max-width: unset!important;">
              <div [innerHTML]="sanitize(result.text)" class="h10-text black-20 bg-transparent"></div>
            </div>
          </ng-template>
        </div>
      </div>
        </div>
      </div>
    </ng-template>

  </p-virtualScroller>

</div>
